<template>
<v-toolbar extended dense flat >
  <v-toolbar-title >{{title}}
  </v-toolbar-title>
  <template slot="extension" >
    <v-btn v-if="withPersonal"
      @click="pickMe"
      color="primary"
      :small="small"
      :outlined="selected !== 'me'" >Personal</v-btn>
    <template v-if="spacesIOwnList && spacesIOwnList.length > 0" >
      <v-divider v-if="withPersonal" vertical class="mx-3" />
      <v-btn
        v-for="space in spacesIOwnList"
        @click="pickSpace(space)"
        :key="space.id"
        :small="small"
        color="primary"
        class="mr-2"
        :outlined="selected !== space.id" >
        {{space.title}}
        <!-- <v-btn small icon
          v-if="withEdit"
          @click.prevent="editSpace(space)" >
          <v-icon small >mdi-pencil</v-icon></v-btn> -->
      </v-btn>
      <v-progress-circular
        v-if="global.request.lookups.loading"
        color="amber" width="2" indeterminate />
      <v-spacer/>
      <v-btn icon outlined
        v-if="withNewSpace"
        @click="newspacedialog=true"
        :small="small" class="mr-2" >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
  </template>

  <v-dialog v-model="newspacedialog" >
    <space-wizard
      v-if="newspacedialog"
      :user="me"
      :touch="touch"
      v-model="selectedSpace"
      @close="newspacedialog=false" />
  </v-dialog>
</v-toolbar>
</template>

<script>
import {mapGetters} from 'vuex'
import SpaceWizard from '@/components/actions/wizards/SpaceWizard/Index.vue'
export default {
  name: 'GuideToolbar',
  components: {SpaceWizard},
  props: {
    title: { type: String },
    withPersonal: { type: Boolean, default: false },
    withNewSpace: { type: Boolean, default: false },
    withEdit: { type: Boolean, default: false },
    small: { type: Boolean, default: false }
  },
  data () {
    return {
      newspacedialog: false,
      selected: null,
      selectedSpace: null,
      touch: 0
    }
  },
  watch: {
    numSpaces () {
      this.setDefaultSelected()
    },
    routePath () {
      this.setDefaultSelected()
    },
    newspacedialog () {
      this.touch++
    }
  },
  methods: {
    pickMe () {
      this.selected = 'me'
      this.$emit('selected', {type: 'practitioner', data: this.me})
    },
    pickSpace (space) {
      this.selected = space.id
      this.$emit('selected', {type: 'space', data: space})
    },
    editSpace (space) {
      this.pickSpace(space.id)
      this.selectedSpace=space
      this.newspacedialog = true
    },
    setDefaultSelected () {
      if (this.numSpaces > 0 && !this.withPersonal) {
        this.pickSpace(this.spacesIOwnList[0])
      }
    }
  },
  computed: {
    ...mapGetters('identity', ['me', 'spacesIOwnList']),
    numSpaces () {
      if (this.spacesIOwnList) { return this.spacesIOwnList.length }
      return 0
    },
    routePath () {
      return this.$route.path
    }
  }
}
</script>